import React from 'react'
import { useApolloClient } from 'react-apollo'

import { EnvProviderProps, withEnv } from '@acorns/web-utils'
import styled from 'styled-components'

import { Heading2 } from 'components/typography'
import { style } from 'theme'
import { logout } from 'utils/session'

const Logout = styled(Heading2)`
  width: 100px;
  height: 19px;
  text-align: right;
  color: #898e8f;
  padding-right: 20px;
`

const StyledButton = styled.button`
  text-decoration: none;
  color: #898e8f;
  background-color: ${style((theme) => theme.colors.white)};
  border: none;
  font-size: inherit;
  font-weight: inherit;
  cursor: pointer;
`

const LogoutNav = ({ env }: EnvProviderProps) => {
  const apolloClient = useApolloClient()

  const handleClick = async () => {
    const url = env.get('loginUrl')
    await logout(apolloClient)
    window.location.href = url
  }

  return (
    <Logout>
      <StyledButton onClick={handleClick}>Log Out</StyledButton>
    </Logout>
  )
}

export default withEnv(LogoutNav)
